<template>
  <div class="introContainer">
    <img src="../../assets/images/RR_logo@2x.png">
    <span class="titleText">Process Standardisation</span>
    <span class="disclaimer">

      <br>
      <div >
        This application, any information provided within it or via any links contained in it (together the “Materials”)<br>
        are provided for use by Rolls-Royce suppliers for the purpose of supporting the elimination of defects in the manufacture of Rolls-Royce products.
        They may not be used for any other purpose.
      </div>
      <br>
      <div>
        The Materials are provided on an “as is” basis without any warranty, representation or guarantee as to their accuracy, completeness, fitness for purpose or otherwise. <br>
        In particular,  Rolls-Royce does not guarantee that the implementation of the guidance set out in the Materials will result in compliance with any relevant contractual, <br>
        legislative or regulatory requirements and users of the guidance remain solely responsible for ensuring such compliance.  Neither Rolls-Royce nor any of its affiliates or<br>
        employees will be liable for any loss suffered as a result of or in connection with the use of the Materials.

       </div>
        <br>
      <span>
        Rolls-Royce reserves the right to withdraw access to the Materials at any time.
      </span>
    </span>
    <button class="btn-outline-primary" v-on:click="navigateHome">
      Start
    </button>
  </div>
</template>

<script>

	export default {
		components: {
    },

		data () {
			return {
			}
		},

		mounted () {
		},

		methods: {
      navigateHome() {
        this.$router.push("/home");
      }
    }
  }

</script>
<style scoped>
.introContainer{
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.titleText{
  font-family: RRPioneer;
  font-size: 64px;
  color: #10069F;
}
.disclaimer{
  text-align: center;
  font-size: 18px;
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.btn-outline-primary{
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 15px;
  font-size: 25px;
  padding: 10px;
  border: 1px solid #007bff;
  border-radius: 5px;
  margin-top: 60px;
  width: 350px;
  height: 80px;
  color: #FFFFFF;
  background: #007bff;
}
</style>